<template>
  <v-container fluid class="pa-2">
    <v-row>
      <v-col>
        <h2 class="mb-3">
          <div v-if="iconSrc" class="mb-1 mr-2 pull-left asset-icon-container">
            <img :src="iconSrc" :style="styleIconColor" class="asset-icon" />
          </div>
          <div class="pull-left">{{ title }}</div>
          <div class="clearfix"></div>
        </h2>
        <Loader v-if="!details" text="" color="white"></Loader>
        <div v-if="details">
          <div v-if="type" class="mb-1">
            <span class="application-heading">Type:</span> {{ type }}
          </div>

          <div v-if="fullAddress" class="mb-1">
            <span class="application-heading">Full Address:</span>
            {{ fullAddress }}
          </div>
          <div v-if="country && country.name" class="mb-1 countries-list">
            <span class="application-heading">Country:</span>
            <span v-if="!country.flagUrl"></span>
            <DetailsListItemCountryChip
              v-if="country.code && country.name && country.flagUrl"
              :key="country.code"
              :name="country.name"
              :code="country.code.toUpperCase()"
              :flagUrl="country.flagUrl"
              theme="dark"
            ></DetailsListItemCountryChip>
          </div>
          <div v-if="created" class="mb-1">
            <span class="application-heading">Created:</span> {{ created }}
          </div>
          <div v-if="updated" class="mb-1">
            <span class="application-heading">Updated:</span> {{ updated }}
          </div>
          <div v-if="expiration" class="mb-1">
            <span class="application-heading">Expiration:</span>
            {{ expiration }}
          </div>

          <div v-if="customFields" class="mb-1">
            <div v-for="(value, key, $index) in customFields" :key="$index">
              <span class="application-heading"
                >{{ getCustomFieldLabel(key) }}:</span
              >
              {{ value }}
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import lodashGet from "lodash/get";
import { upperCaseFirstLetter } from "@/common/basic.utilities";

import { mapGetters } from "vuex";
import { MODULE_PREFIX_HOME } from "@/store";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { getAssetById } from "@/services/assetManagement/assets.service";
import { getCssColorFilter } from "@/common/color.utilities";

export default {
  name: "AssetsDetails",
  components: {
    Loader: () => import("@/components/common/Loader"),
    DetailsListItemCountryChip: () =>
      import("@/components/common/details/DetailsListItemCountryChip"),
  },
  data: () => ({
    details: null,
    id: null,
  }),
  computed: {
    ...mapGetters({
      detailsSidebar: MODULE_PREFIX_HOME + "detailsSidebar",
    }),
    title() {
      if (this.details?.title) {
        return this.details.title;
      }
      return null;
    },
    fullAddress() {
      if (this.details?.fullAddress) {
        return this.details.fullAddress;
      }
      return null;
    },
    country() {
      if (this.details?.country) {
        return this.details.country;
      }
      return null;
    },
    created() {
      if (this.details?.formatted?.created) {
        return this.details.formatted.created;
      }
      return null;
    },
    updated() {
      if (this.details?.formatted?.updated) {
        return this.details.formatted.updated;
      }
      return null;
    },
    expiration() {
      if (this.details?.formatted?.expirationDate) {
        return this.details.formatted.expirationDate;
      }
      return null;
    },
    type() {
      if (this.details?.assetType?.title) {
        return this.details.assetType.title;
      }
      return null;
    },
    customFields() {
      if (this.details?.customFields) {
        return this.details.customFields;
      }
      return null;
    },
    iconSrc() {
      if (this.details?.assetType?.icon) {
        return require(`@/assets/images/icons/assetManagement/asset_${this.details.assetType.icon}.png`);
      }
      return null;
    },
    styleIconColor() {
      if (this.details?.assetType?.color) {
        const filter = getCssColorFilter(this.details.assetType.color);
        if (filter) {
          return {
            filter: filter,
          };
        }
      }
      return null;
    },
  },
  mounted() {
    if (
      this.detailsSidebar.selected === DETAIL_SIDEBAR_TYPES.assets &&
      lodashGet(this.detailsSidebar, "features[0].properties.gid")
    ) {
      this.id = this.detailsSidebar.features[0].properties.gid;
      this.getDetails();
    }
  },
  methods: {
    async getDetails() {
      this.details = await getAssetById(this.id);
    },
    getCustomFieldLabel(label) {
      return label ? upperCaseFirstLetter(label) : label;
    },
  },
  beforeDestroy() {
    this.details = null;
    this.id = null;
  },
};
</script>

<style scoped>
.asset-icon-container {
  background-color: white;
  height: 40px;
  width: 40px;
  border-radius: 20px;
}
.asset-icon {
  width: 25px;
  height: 25px;
  position: relative;
  top: 7px;
  left: 7px;
}
.countries-list {
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(auto-fit, 63px);
}
</style>
